import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans, useTranslation } from 'react-i18next';
import { Field } from 'formik';

import { FormSection } from 'common/components/FormSection';
import { Link } from 'common/components/Link';
import { ImageField, LinkField, TextField } from 'common/components/FormField';
import {
    FOOTER_IMAGE_MAX_SIZE,
    FOOTER_IMAGE_TYPE,
} from 'common/constants/files';
import { Banner } from 'common/components/Banner';
import { Img } from 'common/components/Img';
import PLUVO_FOOTER from 'assets/images/pluvo-footer.webp';
import { IMAGE_VARIANTS } from 'common/constants/image';
import { EImageVariant } from 'common/types';

export const FooterForm = () => {
    const [translate] = useTranslation();
    const smallScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.only('xs')
    );

    return (
        <FormSection
            description={
                <Box>
                    <Trans
                        components={{
                            a: <Link rel="noreferrer" underline="always" />,
                        }}
                        i18nKey="academySettingsForm.footerDescription"
                    />
                </Box>
            }
            title={translate('academySettingsForm.footerTitle')}
        >
            <Stack
                direction={smallScreen ? 'column-reverse' : 'row'}
                spacing={2}
                sx={{ mt: 2 }}
            >
                <Box sx={{ width: '100%' }}>
                    <Field
                        acceptedFileTypes={FOOTER_IMAGE_TYPE}
                        component={ImageField}
                        helperText={translate('imageSizeDescription', {
                            width: IMAGE_VARIANTS[EImageVariant.Logo].minWidth,
                            height: IMAGE_VARIANTS[EImageVariant.Logo]
                                .minHeight,
                        })}
                        imageSize="contain"
                        imageVariant={EImageVariant.Logo}
                        label={translate(
                            'academySettingsForm.footerImage.label'
                        )}
                        maxUploadSize={FOOTER_IMAGE_MAX_SIZE}
                        name="footerImage"
                    />
                </Box>

                <Box sx={{ width: '100%' }}>
                    <Banner>
                        <Box sx={{ py: 1, px: 2 }}>
                            {translate(
                                'academySettingsForm.footerImage.description'
                            )}
                        </Box>
                        <Box sx={{ mt: 'auto' }}>
                            <Img src={PLUVO_FOOTER} />
                        </Box>
                    </Banner>
                </Box>
            </Stack>
            <Field
                component={TextField}
                label={translate('academySettingsForm.footerText')}
                name="footerText"
            />
            <LinkField
                label={translate('academySettingsForm.footerLink')}
                name="footerLink"
            />
        </FormSection>
    );
};
